import { NavPage } from '@/components/breadcrumbs/Breadcrumbs';
import BreadcrumbPageHeader from '@/layouts/BreadcrumbPageHeader';
import { PageLoading } from '@/layouts/PageLoading';
import { PageTitle } from '@/utils/Title';
import { FunctionComponent, Suspense } from 'react';
import EditMspWizard from './EditMspWizard';

const MspSettingsPageContent: FunctionComponent = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: 'Settings',
      to: ''
    }
  ];

  return (
    <>
      <BreadcrumbPageHeader breadcrumbs={breadcrumbs}>
        <div className="flex justify-between gap-5 items-center font-bold">
          <h3 className="text-3xl">MSP Settings</h3>
        </div>
      </BreadcrumbPageHeader>
      <div className="flex-1 overflow-y-auto">
        <EditMspWizard />
      </div>
    </>
  );
};

const MspSettingsPage: FunctionComponent = () => {
  return (
    <>
      <PageTitle>MSP Settings</PageTitle>
      <Suspense fallback={<PageLoading />}>
        <MspSettingsPageContent />
      </Suspense>
    </>
  );
};

export default MspSettingsPage;
